import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=fed58fcc&scoped=true&"
var script = {}
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=fed58fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed58fcc",
  null
  
)

export default component.exports